import React from 'react';
import { Typography, Box as BoxMui } from '@mui/material';
import { useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';

import { useStylesModalOffer } from './hooks/useStyles';
import { getNameQuantity, thousands } from '../../../../../utils/utils';
import { IProduct, PriceValue } from '../../../../../interfaces/product';
import { ReactComponent as Building } from '../../../../../../_base/layout/assets/layout-svg-icons/building-01.svg';
import { ReactComponent as Box } from '../../../../../../_base/layout/assets/layout-svg-icons/box.svg';
import { ReactComponent as Truck } from '../../../../../../_base/layout/assets/layout-svg-icons/truck-01.svg';
import ProductCount from '../ProductCount';
import { selectMe } from '../../../cart/selectors';
import { ICompany } from '../../../../../interfaces/companies';
import { ColorButton } from '../../../../../components/other/Buttons';

export function OffersForBuyerGrid({
  prices,
  product,
  setCompany,
}: {
  prices: PriceValue[];
  product: IProduct;
  setCompany?: (company: ICompany) => void;
}) {
  const me = useSelector(selectMe);
  const { classes } = useStylesModalOffer();
  return (
    <div className={classes.containerOffersGrid}>
      {prices.map((i, index) => {
        const quantityLevel = getNameQuantity(i?.vendor?.quantity_level);
        const secondQantityLevel = getNameQuantity(i?.vendor?.second_quantity_level);
        return (
          <div key={index} className={classes.offerTableGrid}>
            <BoxMui display='flex' flexDirection='row' justifyContent='space-between'>
              {me?.is_admin ? (
                <Typography
                  component='p'
                  className={classes.vendorTitle}
                  style={{ fontWeight: 'normal', fontSize: 16 }}
                >
                  {i.vendor?.name}
                </Typography>
              ) : (
                <Typography
                  component='p'
                  className={classes.vendorTitle}
                  style={{ fontWeight: 'normal', fontSize: 16 }}
                >
                  {i.vendor?.code ? `Склад ${i.vendor.code}` : `Склад ${index + 1}`}
                </Typography>
              )}
              {setCompany && i.vendor && (
                <ColorButton
                  color='#006997'
                  onClick={() => setCompany(i.vendor as unknown as ICompany)}
                  className={classes.colorButtonIconView}
                >
                  <EditIcon htmlColor='#fff' />
                </ColorButton>
              )}
            </BoxMui>
            <ProductCount
              showPrice
              product={product}
              priceBold
              priceValue={i}
              style={{ flexDirection: 'column', gap: 15 }}
            />
            <div className={classes.containerPricesGrid}>
              {i.prices?.map(item => (
                <div className={classes.priceGrid}>
                  <Typography component='p' className={classes.price}>
                    {`от ${item.amount} шт.`}
                  </Typography>
                  <div className={classes.onceColumn}>
                    <Typography component='p' className={classes.priceBold}>
                      {thousands(String(item.price || '0'))}
                    </Typography>
                    <Typography className={classes.rub} component='p'>
                      <span className={classes.rub}>₽</span>
                    </Typography>
                  </div>
                </div>
              ))}
            </div>
            <div className={classes.containerOffersTable}>
              <div className={classes.containerStock}>
                <div className={classes.containerTitle}>
                  <Building />
                  <Typography className={classes.gridQuantityTitle} component='p'>
                    Наличие на складе
                  </Typography>
                  <Typography className={classes.gridQuantityValue} component='p'>
                    {i.vendor?.stock_quantity
                      ? `${thousands(String(i.vendor?.stock_quantity || '0'))} шт.`
                      : quantityLevel || '0 шт.'}
                  </Typography>
                </div>
                <div className={classes.containerTitle}>
                  <Truck />
                  <Typography className={classes.gridQuantityTitle} component='p'>
                    Срок поставки
                  </Typography>
                  <Typography className={classes.gridQuantityValue} component='p'>
                    1 дн.
                  </Typography>
                </div>
              </div>
              <div className={classes.containerStock}>
                <div className={classes.containerTitle}>
                  <Box />
                  <Typography className={classes.gridQuantityTitle} component='p'>
                    Количество под заказ
                  </Typography>
                  <Typography className={classes.gridQuantityValue} component='p'>
                    {i.vendor?.order_quantity
                      ? `${thousands(String(i.vendor?.order_quantity || '0'))} шт.`
                      : secondQantityLevel || '0 шт.'}
                  </Typography>
                </div>
                <div className={classes.containerTitle}>
                  <Truck />
                  <Typography className={classes.gridQuantityTitle} component='p'>
                    Срок поставки
                  </Typography>
                  <Typography className={classes.gridQuantityValue} component='p'>
                    {`${thousands(String(i.vendor?.delivery_period || '0'))} дн.`}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
